import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../data/content";

const MarqueeBar = ({ inverted = false }) => {
  return (
    <div
      className={`py-8 md:py-10 border-y border-black/30 ${
        inverted ? "bg-[var(--ink)] text-[var(--bg)]" : "bg-[var(--surface)] text-[var(--ink)]"
      }`}
      data-testid="marquee-bar"
    >
      <Marquee gradient={false} speed={50} pauseOnHover>
        {[...MARQUEE_ITEMS, ...MARQUEE_ITEMS].map((item, i) => (
          <span
            key={i}
            className="marquee-text text-4xl md:text-6xl lg:text-7xl px-8 md:px-12 flex items-center gap-8 md:gap-12"
          >
            {item}
            <span aria-hidden className="text-[var(--accent)] text-2xl md:text-4xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeBar;
